"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("firebase/storage");
var firebase = require('firebase/app');
var _default = exports.default = {
  methods: {
    uploadFileToStorage: function () {
      var _uploadFileToStorage = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(file, savePath) {
        var fileURL, storageRef;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // console.log('uploadFileToStorage[start] - ' + savePath)
              fileURL = null;
              storageRef = firebase.storage().ref().child(savePath);
              _context2.n = 1;
              return storageRef.put(file).then(/*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(snapshot) {
                  return (0, _regenerator2.default)().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        _context.n = 1;
                        return snapshot.ref.getDownloadURL().then(function (downloadURL) {
                          console.log('uploadFileToStorage[url] - ' + downloadURL);
                          fileURL = downloadURL;
                        }, function (error) {
                          console.log(error);
                        });
                      case 1:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                return function (_x3) {
                  return _ref.apply(this, arguments);
                };
              }(), function (error) {
                console.log(error);
              });
            case 1:
              return _context2.a(2, fileURL);
          }
        }, _callee2);
      }));
      function uploadFileToStorage(_x, _x2) {
        return _uploadFileToStorage.apply(this, arguments);
      }
      return uploadFileToStorage;
    }(),
    deleteFileFromStorage: function () {
      var _deleteFileFromStorage = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(savePath) {
        var isDeleted, storageRef;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              // console.log('deleteFileFromStorage[start] - ' + savePath)
              isDeleted = false;
              storageRef = firebase.storage().ref().child(savePath);
              _context4.n = 1;
              return storageRef.delete().then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
                return (0, _regenerator2.default)().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      // console.log('deleteFileFromStorage[success]')
                      isDeleted = true;
                    case 1:
                      return _context3.a(2);
                  }
                }, _callee3);
              })), function (error) {
                console.log(error);
              });
            case 1:
              return _context4.a(2, isDeleted);
          }
        }, _callee4);
      }));
      function deleteFileFromStorage(_x4) {
        return _deleteFileFromStorage.apply(this, arguments);
      }
      return deleteFileFromStorage;
    }()
  }
};